import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { comparisonRows } from '../data/content';
export function Comparison() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-33" data-mp="1g8ue71hjjvos">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-34" data-mp="1l6vyfpqpe11u">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-3 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-35" data-mp="1l5kxdxon77ef">
          <ScaleIcon className="h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-36" data-mp="1uwp98oj0uc51" />
          Metodo tradizionale vs Atlante
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg text-blue-900/70 md:text-xl" data-id="element-37" data-mp="23xvqx0xepszv">
          Confronta il classico metodo di studio con l'Atlante Visivo di Chinesiologia
        </p>

        <div className="mx-auto mt-12 max-w-4xl overflow-x-auto rounded-2xl ring-1 ring-blue-100" data-id="element-38" data-mp="28um85rky6umv">
          <table className="w-full min-w-[32rem] border-collapse text-left" data-id="element-39" data-mp="9m8niq0g8k7v">
            <caption className="sr-only" data-id="element-40" data-mp="ej7h97g7ap5j">
              Confronto tra il metodo di studio tradizionale e l'Atlante Visivo di Chinesiologia
            </caption>
            <thead data-id="element-41" data-mp="1h9qsb1grfz70">
              <tr className="bg-blue-50" data-id="element-42" data-mp="1h97bjo2ujguk">
                <th scope="col" className="px-5 py-4 text-sm font-extrabold text-blue-900/60 md:px-6" data-id="element-43" data-mp="1h8619ltnmydw">
                  Metodo tradizionale
                </th>
                <th scope="col" className="bg-blue-100 px-5 py-4 text-sm font-extrabold text-blue-800 md:px-6" data-id="element-44" data-mp="24zbcfnonh2hv">
                  Atlante Visivo
                </th>
              </tr>
            </thead>
            <tbody data-id="element-45" data-mp="1vx24n5krnn86">
              {comparisonRows.map(row => <tr key={row.old} className="border-t border-blue-100 bg-white" data-id="element-46" data-mp="1qyquetqk7apf">
                  <td className="px-5 py-4 text-blue-900/60 md:px-6" data-id="element-47" data-mp="kk9ge4r6pgwv">{row.old}</td>
                  <td className="bg-blue-50 px-5 py-4 font-semibold text-blue-800 md:px-6" data-id="element-48" data-mp="fkn4pzr088q6">
                    {row.atlas}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-4xl" data-id="element-49" data-mp="lzu92hes30sr">
          Il tuo prossimo esame può essere diverso.
        </p>
      </div>
    </section>;
}